import { render, staticRenderFns } from "./FormBuilderElement.vue?vue&type=template&id=4fa7e1b8&scoped=true"
import script from "./FormBuilderElement.vue?vue&type=script&lang=js"
export * from "./FormBuilderElement.vue?vue&type=script&lang=js"
import style0 from "./FormBuilderElement.vue?vue&type=style&index=0&id=4fa7e1b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa7e1b8",
  null
  
)

export default component.exports